export default __webpack_public_path__ + "static/media/shard-stigma.e61c50f8.glb";